import { WEB_FONT_FAMILY } from 'HubStyleTokens/misc';

// Needed for jasmine spying
export const getFontFamilyToken = () => WEB_FONT_FAMILY;